<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="model.id ? '编辑' : '新建'"
      class="edit"
      width="1000px"
      top="5vh"
      @close="reset()">
    <el-form
        ref="form"
        v-loading="contentLoading"
        :model="model"
        :rules="ruleValidate"
        class="form"
        label-width="80px">
      <div class="vm-separate">
        <el-form-item label="产品名" prop="name">
          <el-input v-model="model.name" placeholder="请输入"/>
        </el-form-item>
        <div/>
      </div>
      <div class="vm-separate">
        <el-form-item label="类别名" prop="categoryName">
          <el-input v-model="model.categoryName" placeholder="请输入" readonly>
            <el-button slot="append" icon="el-icon-search" @click="$refs.onSelectCategory.open()"/>
          </el-input>
          <product-category-selector ref="onSelectCategory" @select="onSelectCategory"/>
        </el-form-item>
        <div/>
      </div>
      <div class="vm-separate">
        <el-form-item label="型号" prop="model">
          <el-input v-model="model.model" placeholder="请输入"/>
        </el-form-item>
        <div/>
      </div>
      <el-form-item label="图片上传">
        <el-upload
            :action="actionUrl"
            :on-success="handleSuccess"
            :on-remove="handleRemove"
            :on-error="handlerError"
            :before-upload="beforeAvatarUpload"
            :file-list="files"
            list-type="picture-card">
          <i class="el-icon-plus"/>
        </el-upload>
      </el-form-item>
      <div
          style="border: 1px solid #e6e6e6;padding-top: 10px;margin-bottom: 20px;padding-bottom: 0;border-bottom: none">
        <div
            v-for="item in tableData"
            :key="item.pkid"
            style="border-bottom: 1px solid #e6e6e6;padding: 10px 20px;margin-bottom: 10px">
          <div v-if="item.groupType===10">
            <div>
              <span style="color: #2D8CF0">
                {{item.groupName}}
              </span>
              <div style="display: flex;flex-direction: row;justify-content: space-between;flex-wrap: wrap">
                <div
                    v-for="entity in item.productIntroductionTemplateParams"
                    :key="entity.pkid"
                    style="width: 50%;display: flex;flex-direction: row;align-items: center;margin-bottom: 10px">
                  <span
                      style="display: block;width: 100px;text-align: right;margin-right: 10px">
                    {{entity.paramName}}
                  </span>
                  <el-input
                      v-if="entity.paramValueType === 20"
                      v-model="entity.paramValue"
                      type="textarea"
                      style="width: 300px"
                      placeholder="请输入"/>
                  <el-input v-else v-model="entity.paramValue" style="width: 300px" placeholder="请输入"/>
                </div>
              </div>
            </div>
          </div>
          <div v-else-if="item.groupType===20">
            <div style="position: relative">
              <span style="color: #2D8CF0">
                {{item.groupName}}
              </span>
              <el-button
                  type="primary"
                  @click="addParamValue(item.productIntroductionTemplateParams)">
                +新增一行
              </el-button>
              <div style="margin-top: 5px">
                <table width="100%" cellspacing="0">
                  <tr style="background: #F5F7FA;">
                    <th
                        v-for="(item1,index1) in item.productIntroductionTemplateParams"
                        :key="index1"
                        style="padding: 10px;">
                      {{item1.paramName}}
                    </th>
                    <th>操作</th>
                  </tr>
                  <tr
                      v-for="(item2,index2) in item.productIntroductionTemplateParams[0].children"
                      :key="index2"
                      class="hover">
                    <td
                        v-for="(item3,index3) in item.productIntroductionTemplateParams"
                        :key="index3"
                        style="padding: 10px">
                      <el-input v-model="item3.children[index2]" style="width: 80%" placeholder="请输入"/>
                    </td>
                    <td>
                      <el-button type="danger" @click="deleteParamValue(item.productIntroductionTemplateParams,index2)">
                        删除
                      </el-button>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="vm-separate">
        <el-form-item label="详情" prop="richDetails">
          <vm-rich-text-editor ref="editor" height="calc(100vh - 430px)" class="editor"/>
        </el-form-item>
        <div/>
      </div>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible=false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">保存</el-button>
    </span>
  </el-dialog>
</template>
<script>
  import ProductCategorySelector from "@/views/information/ProductCategory/ProductCategorySelector.vue";
  import VmRichTextEditor from "@/components/VmRichTextEditor.vue";

  export default {
    name:"ProductEdit",
    components: {ProductCategorySelector, VmRichTextEditor},
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        tableData: [],
        paramValueTable: [],
        files: [],
        actionUrl: window.config.basicServerHttpUrl + "file/upload",
        model: {
          id: 0,
          name: "",
          model: "",
          categoryId: 0,
          categoryName: "",
          richDetails: "",
          remark: "",
          productIntroductionTemplateGroupVOS: [],
          productPictureList: [],
        },
        ruleValidate: {
          name: {required: true, message: "不能为空", trigger: "blur"},
        },
      };
    },
    methods: {
      open(id) {
        this.dialogVisible = true;
        this.model.id = id;
        if (id > 0) {
          this.getData();
        }
      },
      getData() {
        this.$http
          .get("basic", `products/${this.model.id}`)
          .then(resp => {
            this.model = resp;
            this.tableData = resp.productIntroductionTemplateGroupVOS;
            if (this.model.productPictureList) {
              for (const file of this.model.productPictureList) {
                this.files.push({url: this.getFullUrl(file), path: file});
              }
            }
            console.log(this.model);
            this.$refs.editor.setContent(this.model.richDetails);
          });
      },
      handlerError(err, file, fileList) {
        console.log(file);
        console.log(fileList);
        alert(err);
      },
      beforeAvatarUpload(file) {
        let fileType = file.name.substring(file.name.lastIndexOf(".") + 1);
        let isJPG = (fileType === "jpg" || fileType === "jpeg");
        let isPNG = fileType === "png";
        let isLt2M = file.size / 1024 / 1024 < 2;
        if (!isJPG && !isPNG) {
          this.$message.error("上传图片只能是 jpg、png格式!");
        }
        if (!isLt2M) {
          this.$message.error("上传头像图片大小不能超过 2MB!");
        }
        return (isJPG || isPNG) && isLt2M;
      },
      handleSuccess(response, file, fileList) {
        file.path = response;
        this.files = fileList;
      },
      handleRemove(file, fileList) {
        this.files = fileList;
      },
      addParamValue(productIntroductionTemplateParams) {
        console.log(productIntroductionTemplateParams);
        productIntroductionTemplateParams.forEach(item => {
          item.children.push("");
        });
      },
      deleteParamValue(list, index) {
        list.forEach(item => {
          item.children.splice(index, 1);
        });
      },
      getFullUrl(row) {
        console.log(row);
        // `file/download/${row.filePath}/${row.pictureName}`
        let newfileName = row.filePath.substring(row.filePath.lastIndexOf("\\")+1);
        // return  window.config.basicServerUrl + "file/download?uuid=" + row.filePath+"&name=" + row.pictureName;
        return  window.config.fileServerUrl + newfileName;
      },
      handleSubmit() {
        console.log(this.files);
        let list=[];
        for (let i = 0; i < this.files.length; i++) {
          let object = {};
          if (this.files[i].path.id>0) {
            object.pictureName = this.files[i].path.pictureName;
            object.filePath = this.files[i].path.filePath;
          }else{
            object.pictureName = this.files[i].path.originalName.split(".")[0];
            object.filePath = this.files[i].path.fullPath;
          }
          object.rowIndex = i+1;
          list.push(object);
        }
        this.model.productPictureList = list;
        console.log(this.model);
        this.model.productIntroductionTemplateGroupVOS = this.tableData;
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.model.richDetails = this.$refs.editor.getContent();
            this.$http.save("basic", "products", this.model)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$message.success("保存成功");
                this.$emit("save-success");
              })
              .catch(() => {
                this.submitLoading = false;
                this.$message.error("保存失败");
              });
          }
        });
      },
      onSelectCategory(row) {
        console.log(row);
        this.model.categoryId = row.id;
        this.model.categoryName = row.name;
        if (row.templateID > 0) {
          this.getParamList(row.templateID);
        }
      },
      getParamList(templateID) {
        this.$http
          .get("basic", `productIntroductionTemplateGroups/getList/${templateID}`)
          .then(resp => {
            this.tableData = resp;
            console.log(this.tableData);
          });
      },
      reset() {
        this.$refs.editor.setContent("");
        this.$reset("form");
      },
    },
  };
</script>


<style lang="scss" scoped>
  @import "../../../style/index";

  .editor {
    border: 1px solid $border-color;
  }

  .hover:hover {
    background: #F5F7FA;
  }
</style>
